<i18n>
{
	"en": {
		"failedToAddOrderToTrip": "Failed to add order to trip {number}",
		"orderAddedToTrip": "Order added to trip {number}",
		"failedToRemoveOrderTrip": "Failed to remove order from trip",
		"orderRemovedFromTrip": "Order removed from trip"
	},
	"no": {
		"failedToAddOrderToTrip": "Kunne ikke legge til oppdrag på turen {number}",
		"orderAddedToTrip": "Oppdrag lagt til tur {number}",
		"failedToRemoveOrderTrip": "Kunne ikke fjerne ordren fra turen",
		"orderRemovedFromTrip": "Oppdrag fjernet fra turen"
	}
}
</i18n>

<template>
	<div class="new-trip-orders">
		<CargoInformation
			:tripDetails="trip"
			@delete="onRemoveOrders"
			@moveOrder="showMoveLoadedOrder"
			@scheduleOrderForEdi="onScheduleOrder"
			@unscheduleOrderForEdi="onUnscheduleOrder"
			@packageLabel="showSinglePackageLabel"
			@waybill="showSingleWaybill"
			@removeOrderAndMerge="onRemoveOrders($event,true)"
			@removeOrder="onRemoveOrders($event)"
		/>
		<MoveOrderToDifferentTripSelect
			:isShown="moveLoadedOrderVisible"
			:currentTrip="trip"
			:order="selectedOrder"
			:disableSubmit="moveLoadedOrderProcessing"
			@close="moveLoadedOrderVisible = false"
			@moveOrder="onMoveOrderToDifferentTrip"
		/>
		<ConfirmRemoveTripOrder
			:isShown="confirmRemoveTripOrderVisible"
			:trip="trip"
			@close="toggleRemoveTripOrder(false)"
			@confirm="confirmRemoveOrdersFromTrip"
		/>
	</div>
</template>

<script>
import CargoInformation from './CargoInformation';
import MoveOrderToDifferentTripSelect from './modals/MoveOrderToDifferentTripSelect';
import ConfirmRemoveTripOrder from './modals/ConfirmRemoveTripOrder';

import { mapActions } from './store/newTrip.store.js';

export default {
	components: {
		CargoInformation,
		MoveOrderToDifferentTripSelect,
		ConfirmRemoveTripOrder,
	},
	props: {
		trip: Object,
	},
	data() {
		return {
			moveLoadedOrderProcessing: false,
			moveLoadedOrderVisible: false,
			ordersToRemove: null,
			confirmRemoveTripOrderVisible: false,
			mergeOrder: false,
			selectedOrder: {},
		};
	},
	methods: {
		...mapActions([
			'removeOrdersFromTrip',
			'unscheduleSubOrderForEdi',
			'scheduleSubOrderForEdi',
			'getWaybill',
			'getPackageLabel',
			'moveOrderToDifferentTrip'
		]),
		toggleRemoveTripOrder(value) {
			this.confirmRemoveTripOrderVisible = value;
		},
		onRemoveOrders(orders, merge = false) {
			// TODO not been tested after tripPatch rewrite.
			if (!orders || this.trip.type.internalCode === 'external') return;
			if (Array.isArray(orders))
				this.ordersToRemove = orders;
			else
				this.ordersToRemove = [orders];
			this.mergeOrder = merge;
			this.toggleRemoveTripOrder(true);
		},
		confirmRemoveOrdersFromTrip() {
			try {
				this.removeOrdersFromTrip({ orders: this.ordersToRemove, merge: this.mergeOrder });
				this.$notify({
					type: 'success',
					title: `${this.$t('orderRemovedFromTrip')}`
				});
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t('failedToRemoveOrderTrip')
				});
			}
		},
		onScheduleOrder(obj) {
			this.scheduleSubOrderForEdi(obj);
		},
		onUnscheduleOrder(obj) {
			this.unscheduleSubOrderForEdi(obj);
		},
		showMoveLoadedOrder({ order }) {
			this.selectedOrder = order;
			this.moveLoadedOrderVisible = true;
		},
		async onMoveOrderToDifferentTrip(data) {
			this.moveLoadedOrderProcessing = true;
			this.$notify({ clean: true });
			try {
				await this.moveOrderToDifferentTrip(data);
				this.$notify({
					type: 'success',
					title: `${this.$t('orderAddedToTrip', { number: data.newTrip.tripNumber })}`
				});
				this.moveLoadedOrderVisible = false;
			} catch (e) {
				this.$notify({
					type: 'error',
					title: this.$t(e.message || 'failedToAddOrderToTrip', { number: data.newTrip.tripNumber }),
					duration: -1
				});
			}
			this.moveLoadedOrderProcessing = false;
		},
		showSingleWaybill(id) {
			this.getWaybill([id]);
		},
		showSinglePackageLabel(id) {
			this.getPackageLabel([id]);
		},
	},
};
</script>

<style>
.new-trip-orders {
	height: 98%;
}

</style>